import createSvgIcon from '../Utils/CreateSvgIcon';

/** @deprecated Use `User` from `@gds/Icons/Paths/User` instead. */
export const Dealer = createSvgIcon(
  <path
    d="M8 15L16 15C17.1046 15 18 15.8954 18 17L18 20H6V17C6 15.8954 6.89543 15 8 15ZM4 17C4 14.7909 5.79086 13 8 13L16 13C18.2091 13 20 14.7909 20 17L20 20L20 22H18H6H4L4 20V17ZM15 7C15 8.65685 13.6569 10 12 10C10.3431 10 9 8.65685 9 7C9 5.34315 10.3431 4 12 4C13.6569 4 15 5.34315 15 7ZM17 7C17 9.76142 14.7614 12 12 12C9.23858 12 7 9.76142 7 7C7 4.23858 9.23857 2 12 2C14.7614 2 17 4.23858 17 7Z"
    fillRule="evenodd"
  />,
  'Dealer',
);
